module.exports = __webpack_public_path__ + "img/event-main.e8c6e78c.svg";